import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { oneOf } from "prop-types";
import swal from "sweetalert2";

import TransactionDetails from "../Components/TransactionDetails";

import transactions from "../../api/transactions";
import { handleError } from "@/util/errorHandler";

class ViewUserTransaction extends Component {
  state = {
    details: {},
    isLoading: true,
    isRefunding: false,
    isAcknowledging: false,
  };

  componentDidMount() {
    this.loadTransaction();
  }

  loadTransaction = async () => {
    const { accountId, id } = this.props.match.params;
    try {
      this.setState({ isLoading: true });
      const details = await transactions.getUserTransaction(accountId, id);

      this.setState({ details });
    } catch (error) {
      handleError(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onClickRefund = async () => {
    const { value: isRefundConfirmed } = await swal({
      title: "Are you sure?",
      text: 'Please click "Yes" to refund',
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (isRefundConfirmed) {
      this.onConfirmRefund();
    }
  };

  onConfirmRefund = async () => {
    try {
      this.setState({ isRefunding: true });
      const { fastTransactionId } = this.state.details;
      await transactions.refund(fastTransactionId);
      swal("Congrats", "Refund successful", "success");

      this.loadTransaction();
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isRefunding: false });
    }
  };

  onClickAcknowledge = async () => {
    const { value: isAcknowledgeConfirmed } = await swal({
      title: "Are you sure?",
      text: 'Please click "Yes" to acknowledge',
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (isAcknowledgeConfirmed) {
      this.onConfirmAcknowledge();
    }
  };

  onConfirmAcknowledge = async () => {
    try {
      this.setState({ isAcknowledging: true });
      const { fastTransactionId } = this.state.details;
      await transactions.acknowledge(fastTransactionId);
      swal({
        title: "Congrats",
        text: "Acknowledge successfully",
        showCancelButton: false,
        confirmButtonText: "Done",
      });

      this.loadTransaction();
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isAcknowledging: false });
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div>
        <Row>
          <Col>
            <TransactionDetails
              loading={this.state.isLoading}
              details={this.state.details}
              onBack={this.goBack}
              type={this.props.type}
              isRefunding={this.state.isRefunding}
              isAcknowledging={this.state.isAcknowledging}
              onClickRefund={this.onClickRefund}
              onClickAcknowledge={this.onClickAcknowledge}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

ViewUserTransaction.propTypes = {
  type: oneOf(["incoming", "outgoing"]).isRequired,
};

export default ViewUserTransaction;
